module.exports = __webpack_public_path__ + "7bba924444fd416836e08300ccd872bb.mp3";